<template>
  <div>
    <tud-drawer></tud-drawer>
    <tud-toolbar></tud-toolbar>
    <main style="min-height: 90vh">
      <!-- <transition name="slide-x-transition" mode="out-in" appear> -->
      <v-progress-linear
        :indeterminate="true"
        height="2"
        v-show="loading"
        color-front="blue-grey"
        color-back="blue-grey lighten-2"
      >
      </v-progress-linear>
      <!-- </transition> -->
      <v-container fluid class="pa-1">
        <!-- <transition name="slide-x-transition" mode="out-in" appear> -->
          <v-layout column child-flex>
            <router-view :key="$route.params.id" keep-alive></router-view>
          </v-layout>
        <!-- </transition> -->
      </v-container>
    </main>

    <footer style="padding-bottom: 68px">
      <div class="elevation-0 pl-2 pr-2" style="background-color: transparent; font-size: 0.8em; color: #aaa; text-shadow: 1px 1px 3px #bbb; text-align: center">
        Developed by <a target="_blank" href="https://tudconsult.ro/">TUD</a>
        <br>
        &copy; Verde Smart Data. {{translate('interfata', 'app-copyright')}}
        <br>
        {{translate('interfata', 'app-icon-surse')}}
      </div>
    </footer>

    <tud-snack :messages="messages" :visible="visibleMessages" style="z-index: 12000"></tud-snack>

    <!-- <tud-footer></tud-footer> -->
  </div>
</template>

<script>
  import colorContrast from 'font-color-contrast'
  import LoadingComp from '@/components/Loading.vue'

  export default {
    components: {
      'tud-drawer': () => {
        return {
          // The component to load. Should be a Promise
          component: import('@/components/Drawer.vue'),
          // A component to use while the async component is loading
          loading: LoadingComp,
          // // A component to use if the load fails
          // error: ErrorComp,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200
        }
      },
      'tud-toolbar': () => {
        return {
          // The component to load. Should be a Promise
          component: import('@/components/Toolbar.vue'),
          // A component to use while the async component is loading
          loading: LoadingComp,
          // // A component to use if the load fails
          // error: ErrorComp,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200
        }
      },
      'tud-footer': () => {
        return {
          // The component to load. Should be a Promise
          component: import('@/components/Footer.vue'),
          // A component to use while the async component is loading
          loading: LoadingComp,
          // // A component to use if the load fails
          // error: ErrorComp,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200
        }
      },
      'tud-snack': () => {
        return {
          // The component to load. Should be a Promise
          component: import('@/components/Snackbar.vue'),
          // A component to use while the async component is loading
          loading: LoadingComp,
          // // A component to use if the load fails
          // error: ErrorComp,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200
        }
      }
    },
    computed: {
      client () {
        return this.$store.getters.client
      },
      primaryStyle () {
        if (this.client && this.client.data.colors) {
          return {
            backgroundColor: this.client.data.colors.primary,
            color: colorContrast(this.client.data.colors.primary)
          }
        } else {
          return {}
        }
      },
      loading () {
        return this.$store.getters.getLoading
      },
      messages () {
        return this.$store.getters.snacksMessages
      },
      visibleMessages () {
        return this.$store.getters.snacksVisible
      }
    },
    methods: {
      translate (sheet, item) {
        return this.$store.getters.translate(sheet, item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Layout.vue?224c34f6